import React from 'react';
import { Age, Code } from './LivePage';
import PagedWorkloadPage from './PagedWorkloadPage';

/**
 * Horizontal Pod Autoscalers.
 *
 * Previously rendered a hardcoded row ("web-app-hpa, Deployment/web-app, 2/10") with no API
 * call, and a Create button that only console.log'd — so it looked like a working feature
 * reporting real state. Now live from Steve.
 */
export default function HPA() {
  return (
    <PagedWorkloadPage
      title="Horizontal Pod Autoscalers" kind="HorizontalPodAutoscaler"
      resource="horizontalpodautoscalers" label="autoscalers" detail={false}
      cols={['Name', 'Namespace', 'Reference', 'Min/Max', 'Current', 'Targets', 'Age']}
      renderRow={h => [
        <td key="n"><Code>{h.name}</Code></td>,
        <td key="ns" style={{ color: 'var(--ink-2)', fontSize: 13 }}>{h.namespace}</td>,
        <td key="ref" style={{ fontSize: 12 }}>{h.reference || '—'}</td>,
        <td key="mm">{h.min_replicas}/{h.max_replicas}</td>,
        <td key="c" style={{
          // Sitting at max means the autoscaler has nothing left to give — worth flagging.
          color: h.current_replicas >= h.max_replicas ? 'var(--color-warning-500)' : 'inherit',
          fontWeight: 600,
        }}>{h.current_replicas}</td>,
        <td key="t" style={{ fontSize: 12, color: 'var(--muted)' }}>
          {(h.targets || []).join(', ') || '—'}
        </td>,
        <td key="a"><Age ts={h.created_at} /></td>,
      ]}
    />
  );
}
